import { renderRequiredRule } from '@/utils/renderRulesForm';

export default (cargoInformation) => ({
  numberOfIdenticalLoads: [renderRequiredRule('Пожалуйста введите количество')],
  typeOfCargo: [renderRequiredRule('Пожалуйста введите количество')],
  additionalPackaging: [],
  typeOfPackaging: [
    {
      validator: (rule, value, callback) => {
        if (cargoInformation.additionalPackaging && !value.length) {
          callback(new Error('Пожалуйста выберите тип'));
        }
        callback();
      },
      trigger: 'blur',
    },
  ],
  natureOfCargo: [],
  cargoCost: [renderRequiredRule('Пожалуйста введите стоимость')],
});
